export default __webpack_public_path__ + "527a3c3a14bb50462b1ad743fb678cc4.svg";